import * as React from 'react'
import {Box, LinkBox, LinkOverlay} from "@chakra-ui/react";
import Caret from "../../../../images/caret.svg";


export default function SinglePrevNext(props){

    const dir = props.dir
    const element = props.node
    const text = props.text ?? ''
    const positions = [
        {
            'align' : { 'next' : 'left', 'previous': 'right'},
            'transform' : { 'next': 'rotate(270deg)', 'previous': 'rotate(90deg)'},
            'positionL' : {'next': 'auto', 'previous': '15px'},
            'positionR' : {'next': '15px', 'previous': 'auto'},
            'animateL' : {'next': 'auto !important', 'previous': '0 !important'},
            'animateR' : {'next': '0 !important', 'previous': 'auto !important'},
        }
    ]

    return(
        <LinkBox w={'100%'} textAlign={positions[0].align[dir]}
                 pb={{ base: '10px', lg:'0'}}
                 borderBottom={{ base: '1px solid #DBDFE6', lg:'0'}}
                 sx={{
                    '&:hover svg' : {
                        left: positions[0].animateL[dir],
                        right: positions[0].animateR[dir]
                    }
            }}>
            <Box borderBottom={{ base: '0', lg:'1px solid #DBDFE6'}} pb={{ base: '0', lg:'20px'}} mb={{ base: '0', lg:'20px'}}>
                <Box fontWeight={'bold'}>{text}</Box>
                <Box as={Caret} height={'12px'} top = {{base: '15px', lg: '10px'}} style={{
                    fill: '#336699',
                    transform: positions[0].transform[dir],
                    transition: 'all 0.3s ease-out',
                    position: 'absolute',
                    left: positions[0].positionL[dir],
                    right: positions[0].positionR[dir],
                }}/>
            </Box>
            <Box textAlign={positions[0].align[dir]} maxW={'70%'} float={positions[0].align[dir]}>
                <LinkOverlay href={element.uri} title={element.title}>{element.title}</LinkOverlay>
            </Box>
        </LinkBox>
    )
}